module.exports = __webpack_public_path__ + "static/media/help.bcba6a54.svg";